<template>
  <div>
    <AppHeader />
    <main>
      <div class="wrap">
        <section class="hero">
          <div>
            <h1>Быстрый и надежный VPS<br>прямо в вашем приложении</h1>
            <p class="sub">Безопасное подключение в одно касание</p>
            <p class="lead">MyVPS — это высокая скорость, надёжное шифрование и стабильное подключение на iPhone, Android, Mac и Windows. Серверы без перегрузок и обрывов. Никаких сложных настроек.</p>
            <div class="chips">
              <span class="chip"><b>7 дней</b> за 10 ₽</span>
              <span class="chip">20+ стран</span>
              <span class="chip">Шифрование AES-256</span>
              <span class="chip">До 5 устройств</span>
              <span class="chip">iOS / Android / Win / macOS</span>
            </div>
            <div class="cta-row">
              <a class="btn btn-primary btn-shine" :href="trialStartUrl"><span>Попробовать за 10 ₽</span></a>
              <div class="cta-note">Полный функционал на 7 дней<span>Отмена в любой момент</span></div>
            </div>
            <div class="trust">
              <span><b>120 000+</b> подключений в месяц</span>
              <span><b>24/7</b> поддержка на русском</span>
            </div>
          </div>
          <div class="herovisual">
            <img src="/images/hero-visual.png" alt="Иллюстрация: скорость, безопасность и надёжные VPS серверы myVPS">
          </div>
        </section>

        <section style="padding-top: 0">
          <div class="stats">
            <div class="grid">
              <div><div class="n">&lt; <em>20</em> мс</div><p>пинг до ближайших узлов</p></div>
              <div><div class="n"><em>10</em> Гбит/с</div><p>скоростные серверы</p></div>
              <div><div class="n"><em>99.9</em>%</div><p>гарантированный uptime</p></div>
              <div><div class="n"><em>24</em>/7</div><p>поддержка в чате</p></div>
            </div>
          </div>
        </section>

        <section id="features">
          <p class="eyebrow">Возможности</p>
          <h2 style="margin-top: 12px">Что вы получаете</h2>
          <p class="lead" style="margin-top: 14px">Одна подписка — защита всей семьи или команды. Без консолей, конфигов и ручных настроек.</p>
          <div class="pills">
            <div class="pill p1">
              <div class="txt"><h4>Высокая скорость</h4><p>Серверы 10 Гбит/с и оптимальный маршрут до ближайшего узла</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M13 2L4 14h6l-1 8 9-12h-6z"/></svg></div>
            </div>
            <div class="pill p2">
              <div class="txt"><h4>Защищённый доступ к сети</h4><p>Шифрование AES-256. Трафик не хранится и не передаётся третьим лицам</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6z"/><path d="M9.5 12.5l2 2 3.5-4"/></svg></div>
            </div>
            <div class="pill p3">
              <div class="txt"><h4>Без рекламы</h4><p>Без надоедливых рекламных баннеров и долгих ожиданий</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="5" width="18" height="13" rx="2.5"/><path d="M3 6l9 6 9-6"/><path d="M4 19L20 5"/></svg></div>
            </div>
            <div class="pill p4">
              <div class="txt"><h4>Для всех устройств</h4><p>iOS, Android, Windows и macOS — до 5 устройств на одной подписке</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M11 18.5h2"/></svg></div>
            </div>
            <div class="pill p5">
              <div class="txt"><h4>Подключение в один клик</h4><p>Установка за секунды. ИИ сам выбирает лучший сервер и оптимальные настройки</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="6.5"/><circle cx="12" cy="12" r="10" opacity=".45"/></svg></div>
            </div>
            <div class="pill p6">
              <div class="txt"><h4>Пробный период 7 дней</h4><p>Полный функционал всего за 10 ₽, отмена в любой момент</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 12l-8 8-9-9V4h7z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg></div>
            </div>
            <div class="pill p7">
              <div class="txt"><h4>20+ локаций по всему миру</h4><p>Европа, Азия, Америка, СНГ — переключение занимает секунды</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c2.5 2.5 3.8 5.8 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.8-3.8-9s1.3-6.5 3.8-9z"/></svg></div>
            </div>
            <div class="pill p3">
              <div class="txt"><h4>4K стриминг без буферизации</h4><p>Оптимизированные узлы для видео, звонков и загрузок</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M10 8.5l6 3.5-6 3.5z" fill="currentColor" stroke="none"/></svg></div>
            </div>
            <div class="pill p4">
              <div class="txt"><h4>Поддержка на русском 24/7</h4><p>Отвечаем в чате в любое время дня и ночи</p></div>
              <div class="pico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 13v-1a8 8 0 0116 0v1"/><rect x="2.5" y="13" width="4" height="6" rx="1.5"/><rect x="17.5" y="13" width="4" height="6" rx="1.5"/></svg></div>
            </div>
          </div>
        </section>

        <section id="servers" style="padding-top: 0">
          <div class="servers">
            <p class="eyebrow">Серверы</p>
            <h2 style="margin-top: 12px">Высокоскоростные локации</h2>
            <p class="lead" style="margin-top: 14px">Выбирайте страну вручную или доверьте приложению — оно подключит ближайший узел с минимальным пингом.</p>
            <div class="countries">
              <span v-for="c in countries" :key="c.code" class="country">
                <span class="fi" :class="'fi-' + c.code"></span>{{ c.name }}
              </span>
            </div>
          </div>
        </section>

        <section id="pricing">
          <p class="eyebrow">Тарифы</p>
          <h2 style="margin-top: 12px">Начните с пробной недели</h2>
          <p class="lead" style="margin-top: 14px">Пробный период включает в себя полный доступ ко всем функциям без каких-либо ограничений.</p>
          <div class="plans single">
            <div class="plan trial wide">
              <span class="tag green">7 дней</span>
              <div class="plan-info">
                <div class="name">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="20" height="20" style="color: var(--green)"><rect x="3" y="8" width="18" height="13" rx="1.5"/><path d="M3 8h18v4H3z"/><path d="M12 8v13"/><path d="M12 8c-1.2-3-3.4-4.5-5-3.5S5.8 8 8 8"/><path d="M12 8c1.2-3 3.4-4.5 5-3.5S18.2 8 16 8"/></svg>
                  Пробный доступ
                </div>
                <p class="desc">Полный функционал за символическую плату</p>
                <ul>
                  <li v-for="item in trialFeatures" :key="item">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 12.5l5 5L20 6.5"/></svg>{{ item }}
                  </li>
                </ul>
              </div>
              <div class="plan-cta">
                <div class="price-row">
                  <div class="price">10 ₽ <small>/ 7 дней</small></div>
                  <p class="was"></p>
                </div>
                <a class="btn btn-primary btn-shine" :href="trialStartUrl"><span>Попробовать за 10 ₽</span></a>
              </div>
            </div>
          </div>
          <div class="plans">
            <div v-for="plan in paidPlans" :key="plan.name" class="plan" :class="{ featured: plan.featured }">
              <span v-if="plan.tag" class="tag">{{ plan.tag }}</span>
              <div class="name">{{ plan.name }}</div>
              <p class="desc">{{ plan.desc }}</p>
              <div class="price">{{ plan.price }} ₽ <small>/ {{ plan.period }}</small></div>
              <p class="was">{{ plan.perMonth }}</p>
              <ul>
                <li v-for="item in planFeatures" :key="item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 12.5l5 5L20 6.5"/></svg>{{ item }}
                </li>
              </ul>
              <a class="btn btn-primary" :href="cabinetUrl">Выбрать</a>
            </div>
          </div>
        </section>

        <section id="specs" style="padding-top: 0">
          <p class="eyebrow">Технологии</p>
          <h2 style="margin-top: 12px">Что под капотом</h2>
          <p class="lead" style="margin-top: 14px">Собственная сеть узлов на современном железе с гарантированными ресурсами</p>
          <div class="specs">
            <div v-for="spec in specs" :key="spec.title" class="spec">
              <h3>{{ spec.title }}</h3>
              <p style="color: var(--muted); font-size: 15px; margin-top: 8px">{{ spec.text }}</p>
              <dl>
                <div v-for="row in spec.rows" :key="row.label" class="row">
                  <dt>{{ row.label }}</dt>
                  <dd>{{ row.value }}</dd>
                </div>
              </dl>
            </div>
          </div>
          <div class="note">
            <div style="font-size: 26px; line-height: 1">🛡️</div>
            <div>
              <h3>Ваша безопасность превыше всего</h3>
              <p>Все данные защищены современным шифрованием, а серверы физически изолированы и находятся под постоянным контролем — никто посторонний не получит доступ к вашему трафику.</p>
            </div>
          </div>
        </section>

        <section id="faq" style="padding-top: 0">
          <p class="eyebrow">FAQ</p>
          <h2 style="margin-top: 12px; margin-bottom: 20px">Частые вопросы</h2>
          <details v-for="(item, i) in faq" :key="item.q" :open="openFaq === i" @toggle="onFaqToggle($event, i)">
            <summary>{{ item.q }}</summary>
            <p>{{ item.a }}</p>
          </details>
        </section>

        <section style="padding-top: 0">
          <div class="final">
            <h2>Готовы подключиться?</h2>
            <p>Активируйте 7 дней пробного доступа и настройте VPS сервер прямо в приложении — подключение займет не более одной минуты.</p>
            <div class="row">
              <a class="btn btn-primary btn-shine" :href="trialStartUrl"><span>Попробовать за 10 ₽</span></a>
            </div>
          </div>
        </section>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import AppHeader from '../components/AppHeader.vue'
import AppFooter from '../components/AppFooter.vue'
import { cabinetUrl, trialStartUrl } from '../cabinetUrls'

const openFaq = ref(0)

const onFaqToggle = (event, i) => {
  if (event.target.open) {
    openFaq.value = i
  } else if (openFaq.value === i) {
    openFaq.value = -1
  }
}

const trialFeatures = [
  'Моментальная активация',
  'Все локации и протоколы',
  'Отмена в любой момент'
]

const planFeatures = [
  'Все локации и протоколы',
  'До 5 устройств',
  'Отмена в любой момент'
]

const paidPlans = [
  {
    name: '1 месяц',
    desc: 'Полный доступ на 30 дней',
    price: '399',
    period: 'мес',
    perMonth: '399 ₽ в месяц',
    tag: '',
    featured: false
  },
  {
    name: '6 месяцев',
    desc: 'Выгоднее, чем оплачивать помесячно',
    price: '1 690',
    period: '6 мес',
    perMonth: '282 ₽ в месяц',
    tag: '',
    featured: false
  },
  {
    name: '1 год',
    desc: 'Максимальная выгода за год доступа',
    price: '2 390',
    period: 'год',
    perMonth: '199 ₽ в месяц',
    tag: 'Выгодно',
    featured: true
  }
]

const countries = [
  { code: 'at', name: 'Австрия' },
  { code: 'au', name: 'Австралия' },
  { code: 'be', name: 'Бельгия' },
  { code: 'br', name: 'Бразилия' },
  { code: 'gb', name: 'Великобритания' },
  { code: 'de', name: 'Германия' },
  { code: 'dk', name: 'Дания' },
  { code: 'ie', name: 'Ирландия' },
  { code: 'es', name: 'Испания' },
  { code: 'it', name: 'Италия' },
  { code: 'ca', name: 'Канада' },
  { code: 'cn', name: 'Китай' },
  { code: 'nl', name: 'Нидерланды' },
  { code: 'no', name: 'Норвегия' },
  { code: 'ae', name: 'ОАЭ' },
  { code: 'pl', name: 'Польша' },
  { code: 'pt', name: 'Португалия' },
  { code: 'ro', name: 'Румыния' },
  { code: 'sg', name: 'Сингапур' },
  { code: 'us', name: 'США' },
  { code: 'tr', name: 'Турция' },
  { code: 'fi', name: 'Финляндия' },
  { code: 'fr', name: 'Франция' },
  { code: 'cz', name: 'Чехия' },
  { code: 'ch', name: 'Швейцария' },
  { code: 'se', name: 'Швеция' }
]

const specs = [
  {
    title: 'Процессор и ресурсы',
    text: 'Выделенные вычислительные мощности на современных серверных платформах',
    rows: [
      { label: 'Процессор', value: 'AMD EPYC / Intel Xeon' },
      { label: 'Ядра', value: 'до 8 vCPU' },
      { label: 'Память', value: 'до 16 ГБ DDR5' },
      { label: 'Виртуализация', value: 'KVM' }
    ]
  },
  {
    title: 'Пропускная способность',
    text: 'Узлы в дата-центрах уровня Tier III с прямыми стыками до крупных провайдеров.',
    rows: [
      { label: 'Порт', value: 'до 10 Гбит/с' },
      { label: 'Задержка', value: 'от 12 мс' },
      { label: 'Трафик', value: 'Без лимита' },
      { label: 'Дата-центры', value: '20+ стран' }
    ]
  },
  {
    title: 'Диски и хранение',
    text: 'Быстрые NVMe-накопители с аппаратным резервированием и регулярным резервным копированием.',
    rows: [
      { label: 'Накопитель', value: 'NVMe SSD' },
      { label: 'Объём', value: 'до 500 ГБ' },
      { label: 'RAID', value: 'Аппаратный RAID-10' },
      { label: 'Копии', value: 'Ежедневно' }
    ]
  }
]

const faq = [
  { q: 'Что такое MyVPS?', a: 'MyVPS — это сервис, обеспечивающий быстрый и защищённый доступ к интернету через собственные VPS серверы.' },
  { q: 'Как включить MyVPS?', a: 'Скачайте и установите наше официальное приложение и настройте VPS сервер в два клика. Это займёт меньше одной минуты.' },
  { q: 'Какие устройства поддерживаются?', a: 'Управлять сервером можно с iOS, Android, Windows или macOS. Одна учётная запись — до 5 устройств одновременно. Никаких сложных настроек и инструкций.' },
  { q: 'Можно ли отменить подписку в любой момент?', a: 'Да, отменить можно в любой момент прямо в личном кабинете — без звонков в поддержку и скрытых условий. Сервер продолжит работать до конца оплаченного периода, автопродление просто не спишется.' },
  { q: 'Ведёте ли вы логи?', a: 'Мы не просматриваем и не передаём третьим лицам содержимое вашего сервера — доступ к данным есть только у вас. Мониторинг ограничивается техническими показателями: нагрузкой, доступностью и объёмом трафика для тарификации.' },
  { q: 'Для каких задач подходит сервер?', a: 'Сервер подходит для работы, бизнеса и повседневного безопасного использования интернета.' },
  { q: 'Как оплатить и есть ли возврат?', a: 'Принимаем российские банковские карты и СБП. Если сервер не работает и мы не сможем помочь — оформим полный возврат: 14 дней на месячном тарифе и 90 дней на годовом.' }
]
</script>
